import { getLesson } from './lessonHelpers'

export function groupScheduleByDate(schedule) {
    const grouped = schedule.reduce((acc, item) => {
        const lesson = getLesson(item)
        const date = lesson?.class_date || item?.class_date || 'Без даты'

        if (!acc[date]) acc[date] = []
        acc[date].push(item)

        return acc
    }, {})

    return Object.entries(grouped).sort(([leftDate], [rightDate]) => {
        if (leftDate === 'Без даты') return 1
        if (rightDate === 'Без даты') return -1
        return String(leftDate).localeCompare(String(rightDate), 'ru')
    })
}
